/*
 *@description: cookie封装
 *
*/


var cookie = {
    get: function (name) {
        var xarr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
        if (xarr != null)
            // return decodeURIComponent(xarr[2]);
            return unescape(xarr[2]);
        return null;
    },
    set: function (key, value, expiredays, domain) {
        var cookiestr = key + "=" + escape(value)

        if (expiredays != undefined) {
            var exdate = new Date();
            exdate.setDate(exdate.getDate() + expiredays);
            cookiestr += ";expires=" + exdate.toGMTString()
        }
        if (domain != undefined) {
            cookiestr += ";domain=" + domain
        }
        cookiestr += ';path=/'
        document.cookie = cookiestr

    },
    del: function (key, domain) {
        var exdate = new Date((new Date).getTime() - 1);
        if (domain) {
            document.cookie = key + '=;path=/;expires=' + exdate.toGMTString() + ';domain=' + domain;
        }
        else {
            document.cookie = key + '=;path=/;expires=' + exdate.toGMTString();
        }

    }
};

module.exports = cookie;
